"use client";

import { useId } from "react";

export function useSvgId(prefix: string): string {
  return `${prefix}-${useId().replace(/:/g, "")}`;
}
